import React, { Component } from 'react';

import moment, { min } from 'moment';

import ZInfoTicker from '../Utility/ZInfoTicker';


export default class GroupsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: "runs",
            previousReport: null
        }

        this.generateReportList = this.generateReportList.bind(this);
        this.generateReportInfo = this.generateReportInfo.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.activeReport === null && prevProps.activeReport != null) {
            this.setState({ previousReport: prevProps.activeReport });
        }
    }

    generateReportList() {
        let self = this;

        let reportsJsx = [];

        reportsJsx.push((<div className={"card-title"}>{"Reports"}</div>));

        self.props.reportList.forEach(report => {
            reportsJsx.push((
                <div className={"report-outer"} onClick={self.props.openReport.bind(null, report)}>
                    <div className={"material-icons report-icon"}>{"find_in_page"}</div>
                    <div className={"report-name"}>{report.reportName}</div>
                </div>
            ));
        });

        return (
            <div className={"report-list-outer"}>
                <div className={"report-card"}>
                    {reportsJsx}
                </div>
            </div>
        );
    }

    generateReportInfo() {
        let self = this;

        let report = this.props.activeReport;
        if (report === null) {
            report = this.state.previousReport;
            if (report === null) {
                return (
                    <div className={"report-info-outer"}>
                        <div className={"report-card"}>
                            <div className={"card-title"}></div>
                        </div>
                    </div>
                );
            }
        }

        let runsJsx = [];
        report.runs.forEach(run => {
            let runTitle = moment(moment.utc(run.createDate).local()).format("MM/DD/YYYY hh:mm A");

            let runStatus = "";
            switch (run.status) {
                case "Pending": runStatus = "Pending"; break;
                case "Completed": runStatus = "Complete"; break;
                case "Error": runStatus = "Error"; break;
                case "Expired": runStatus = "Expired"; break;
                case "In Progress": runStatus = "In Progress"; break;
                case "Archived": runStatus = "Archived"; break;
                case "Test": runStatus = "Test"; break;
                case "test": runStatus = "Test"; break;
            }


            let showVals = [];
            if (self.props.activeReport != null && this.props.activeReport != undefined) {
                let runFilter = JSON.parse(run.reportFilter);
                let rmap = self.props.activeReport.metaDataReverseMap;


                showVals.push({
                    name: "Date",
                    value: `${runFilter.StartDate} - ${runFilter.EndDate}`
                });

                Object.keys(runFilter).forEach(key => {
                    if (rmap[key]) {
                        showVals.push({
                            name: key === "ReportExportType" ? "Export" : key,
                            value: typeof runFilter[key] === "object" ?
                                (runFilter[key].length === 1 ? rmap[key][runFilter[key][0]] : runFilter[key].length === Object.keys(rmap[key]).length ? "All" : "Multi")
                                : rmap[key][runFilter[key]]
                        });
                    }
                });
            }

            runsJsx.push((
                <div className={"report-run-outer"}>
                    <div className={"indicator " + (runStatus.toLowerCase().replace(/\s/g, '') + "-z")} onClick={this.props.showRunInfo.bind(null, run)}></div>
                    <div className={"title"} onClick={this.props.showRunInfo.bind(null, run)}>{runTitle}</div>
                    <div className={"status"} onClick={this.props.showRunInfo.bind(null, run)}>{runStatus}</div>
                    <ZInfoTicker
                        isFloated={true}
                        info={showVals}
                        centerClick={this.props.showRunInfo.bind(null, run)}
                    />
                </div>
            ));
        });


        return (
            <div className={"report-info-outer"}>
                <div className={"report-card"}>
                    <div className={"card-title"}>{report.reportName}</div>
                    <div className={"material-icons add-button"} onClick={this.props.popNewReport}>{"add"}</div>
                    {runsJsx}
                </div>
            </div>
        );
    }

    render() {

        let reportInfoJsx = this.generateReportInfo();
        let reportListJsx = this.generateReportList();

        return (
            <div className={"reporting-central-outer mode-" + this.props.mode}>
                {reportInfoJsx}
                {reportListJsx}
            </div>
        );
    }
}

